document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mobile-menu]');
  const nav = document.getElementById('PrimaryNavigation');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
    const closeMobileMenu = () => {
      nav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
    };
    nav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMobileMenu();
        menuToggle.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (nav.classList.contains('is-open') && !nav.contains(event.target) && !menuToggle.contains(event.target)) closeMobileMenu();
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1240 && nav.classList.contains('is-open')) closeMobileMenu();
    });
  }
  // Both individual-product and single-product variant buttons carry a real
  // Shopify variant ID. Delegate clicks so Theme Editor section reloads work.
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-voucher-variant]');
    if (!button || button.disabled) return;
    const root = button.closest('[data-voucher-form]');
    if (!root) return;
    const choices = root.querySelectorAll('[data-voucher-variant]');
    choices.forEach(choice => {
      const active = choice === button;
      choice.classList.toggle('is-active', active);
      choice.setAttribute('aria-pressed', String(active));
    });
    const hidden = root.querySelector('[data-voucher-id]');
    const price = root.querySelector('[data-voucher-price]');
    const submit = root.querySelector('[data-voucher-submit]');
    if (hidden) hidden.value = button.dataset.variantId || '';
    if (price) price.textContent = button.dataset.price || '';
    if (submit) {
      const available = button.dataset.available === 'true';
      submit.disabled = !available;
      const label = submit.querySelector('span');
      if (label) label.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  });
  const variantSelect = document.querySelector('[data-main-variant]');
  if (variantSelect) variantSelect.addEventListener('change', () => {
    const price = document.querySelector('[data-main-product-price]');
    if (price) price.textContent = variantSelect.selectedOptions[0].dataset.price;
  });
});
